"use client";

import { cn } from "@/lib/utils/utils";
import CircleIcon from "./circleIcon";
import Flex from "../core/flex";
import Text from "./text";

interface InlineTitleProps {
  icon: React.ReactNode;
  value: string | React.ReactNode;
  className?: string;
}

const InlineTitle: React.FC<InlineTitleProps> = ({
  icon,
  value,
  className,
}) => {
  return (
    <Flex direction="row" spacing={{ all: 2 }} items="center">
      <CircleIcon icon={icon} />
      <div
        className={cn(
          "text-white transition-all duration-200 ease-in-out",
          className
        )}
      >
        {value}
      </div>
    </Flex>
  );
};

export default InlineTitle;
